// extracted by css-extract-rspack-plugin
var _1 = "actions-NkSCf8";
var _2 = "button-AAXdNZ";
var _3 = "copy-jw2jwJ";
var _4 = "kicker-tdacZk";
var _5 = "meta-ynC0bW";
var _6 = "panel-l6bfMh";
var _7 = "title-LIaNC5";
export { _1 as "actions", _2 as "button", _3 as "copy", _4 as "kicker", _5 as "meta", _6 as "panel", _7 as "title" }
